import { ActualsAccount } from "./ActualsAccount";

export class ActualDTO
{
    kaizenDescription!: string;
    kaizenID!: number;
    kaizenNumber!: number;
    fiscalYear!: string;
    kaizenState!: string;
    kaizenActualAccountArray!: ActualsAccount[]; 
    //might need kaizen to handle cancellations and completions
    
    
}

export class PagedResponseActual{
    public pageNumber!: number;
    public pageSize!:number;
    public succeeded!:boolean
    public message!:string;
    public errors!:string;
    public data!:ActualDTO;
}